module.exports = __webpack_public_path__ + "media/content-creator/travel-1-72b3cca5.png";